module.exports = __webpack_public_path__ + "static/media/LRVHP.c6bde6fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/How it works/LRVHP.png
// module id = 305
// module chunks = 0